import { createSlice } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';

export const EBIKES_BY_SKU_PAGE_SIZE = 50;

// Initial state
const initialState = {
  filters: {
    modalFiltersRules: undefined,
    modalConditions: undefined,
  },
};
// Actual Slice
export const ebikesSlice = createSlice({
  name: 'ebikes',
  initialState,
  reducers: {
    filtersModalChangeEbikesSuccess: (state, { payload }) => {
      state.filters.modalConditions = payload;
      if (!payload?.rules?.length) {
        state.filters.modalFiltersRules = undefined;
      }
    },
    filtersModalRulesEbikesChangeSuccess: (state, { payload }) => {
      state.filters.modalFiltersRules = payload;
    },
    resetModalChangeEbikesSuccess: (state) => {
      state.filters.modalConditions = undefined;
      state.filters.modalFiltersRules = undefined;
    },
    // Special reducer for hydrating the state. Special case for next-redux-wrapper
    extraReducers: {
      [HYDRATE]: (state, action) => {
        return {
          ...state,
          ...action.payload.errors,
        };
      },
    },
  },
});

export const {
  filtersModalChangeEbikesSuccess,
  filtersModalRulesEbikesChangeSuccess,
  resetModalChangeEbikesSuccess,
} = ebikesSlice.actions;

export const selectEbikesState = (state) => state.ebikes;

export const filtersModalConditionEbikesChange = (rules) => {
  return (dispatch) => {
    dispatch(filtersModalChangeEbikesSuccess(rules));
  };
};

export const filtersModalRulesEbikesChange = (rules) => {
  return (dispatch) => {
    dispatch(filtersModalRulesEbikesChangeSuccess(rules));
  };
};

export const resetModalEbikesChange = () => {
  return (dispatch) => {
    dispatch(resetModalChangeEbikesSuccess());
  };
};

export default ebikesSlice.reducer;
